
import Vue, { PropType } from 'vue';

import Button from '~/components/builders/Base/Button.vue';
import VerifiedBadge from '~/assets/img/verifiedBadge.png';
import PathImage from '~/assets/img/welcome/path.png';

import { User } from '~/services/IdentityService';
import { CandidateProfileScorer } from '~/utils/candidate/CandidateProfileScorer';
import Checkbox from '~/components/builders/Base/Checkbox.vue';
import CandidateService from '~/services/CandidateService';

export default Vue.extend({
    name: 'WelcomeFinalPage',
    components: {
        Button,
        Checkbox,
    },
    props: {
        user: {
            type: Object as PropType<User>,
            required: true,
        },
        scorer: {
            type: Object as PropType<CandidateProfileScorer>,
            required: true,
        },
        flowCompleted: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        return {
            VerifiedBadge,
            PathImage,
            candidateService: new CandidateService(),
            newsletterLoading: false,
        };
    },
    computed: {
        progress(): number {
            return this.scorer.getProfileScore().progress;
        },
        candidateUser(): User | null {
            return this.$store.getters['profileModule/getCandidate']?.();
        },
    },

    methods: {
        handleCompleteProfile() {
            this.$router.replace(
                this.$URLS.profile,
                () => {
                    this.$emit('flowCompleted');
                },
                () => {
                    this.$emit('flowCompleted');
                }
            );
        },
        handleExploreJob() {
            this.$router.replace(
                this.$URLS.findjobs,
                () => {
                    this.$emit('flowCompleted');
                },
                () => {
                    this.$emit('flowCompleted');
                }
            );
        },
        async onToggleNewsletterSubscription(subscribed: boolean) {
            this.newsletterLoading = true;
            try {
                await this.candidateService.updateCandidateProfile({
                    candidate: { op: 'update', value: { newsletterConsent: subscribed } },
                    userId: this.user.id,
                });
            } finally {
                this.newsletterLoading = false;
            }
        },
    },
});
